$(document).ready(function() {
    if(window.location.href.indexOf('#modal') != -1) {
        $('#address_modal').modal('show');
    }

    // Basic Ajax call to save the PO number to the session.
    const updatePurchaseOrder = function(e) {
        // Get the PO form
        let form = document.querySelector('#submit_order');

        // Get all field data from the form
        // returns a FormData object
        let data = new FormData(form);

        // Convert to a query string
        let queryString = new URLSearchParams(data).toString();

        // Post to the checkout po ajax endpoint
        let storePo = location.pathname.substring(0, location.pathname.lastIndexOf('/')) + "/store_po";

        let xhttp = new XMLHttpRequest();
        xhttp.open("POST", storePo);
        xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhttp.send(queryString);
    }

    const setPurchaseOrderListener = function() {
        // Set up to save the PO number on the checkout form.
        let submit_order = document.getElementById('submit_order');

        if (typeof(submit_order) != 'undefined' && submit_order != null)
        {
            submit_order.addEventListener('input', updatePurchaseOrder);
        }
    }
    setPurchaseOrderListener();

    // Hide the ts and cs error if the customer agrees to them.
    $('input#tandcs_accept').on('click', function(e) {
        if($('input#tandcs_accept:checked').val()) {
            $('#tandcs_accept_error').collapse('hide');
        }
    });
});
